import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["target", "template", "addButton"]
    static values = {
        wrapperSelector: {
            type: String,
            default: ".nested-form-wrapper",
        },
        limit: {
            type: Number,
            default: 10
        }
    }

    connect() {
        this.fieldsCount = this.targetTarget.querySelectorAll(this.wrapperSelectorValue).length
        if (this.fieldsCount >= this.limitValue) {
            this.addButtonTarget.classList.add("hidden!")
        }
    }

    add(event) {
        event.preventDefault()

        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
        this.targetTarget.insertAdjacentHTML("beforeend", content)

        this.fieldsCount++
        if (this.fieldsCount >= this.limitValue) {
            this.addButtonTarget.classList.add("hidden!")
        }

        const customEvent = new CustomEvent("rails-nested-form:add", {bubbles: true})
        this.element.dispatchEvent(customEvent)
    }

    remove(event) {
        event.preventDefault()

        const wrapper = event.target.closest(this.wrapperSelectorValue)

        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.style.display = "none"

            const input = wrapper.querySelector("input[name*='_destroy']")
            input.value = "1"
        }

        this.fieldsCount--
        if (this.fieldsCount < this.limitValue) {
            this.addButtonTarget.classList.remove("hidden!")
        }

        const customEvent = new CustomEvent("rails-nested-form:remove", {bubbles: true})
        this.element.dispatchEvent(customEvent)
    }
}